
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/components/ThemeProvider";

// Layouts and shared components
import NavBar from "@/components/NavBar";
import ProtectedRoute from "@/components/ProtectedRoute";
import CookieConsent from "@/components/CookieConsent";

// Public pages
import Home from "@/pages/Home";
import BlogPost from "@/pages/BlogPost";
import Archive from "@/pages/Archive";
import About from "@/pages/About";
import NotFound from "@/pages/NotFound";
import ConfirmSubscription from "@/pages/ConfirmSubscription";

// Admin pages
import AdminLogin from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import NewPost from "@/pages/admin/NewPost";
import EditPost from "@/pages/admin/EditPost";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <div className="flex min-h-screen flex-col">
              <NavBar />
              <main className="flex-1">
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<Home />} />
                  <Route path="/post/:slug" element={<BlogPost />} />
                  <Route path="/archive" element={<Archive />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/confirm-subscription" element={<ConfirmSubscription />} />
                  <Route path="/admin/login" element={<AdminLogin />} />

                  {/* Protected Admin Routes */}
                  <Route element={<ProtectedRoute />}>
                    <Route path="/admin/dashboard" element={<Dashboard />} />
                    <Route path="/admin/new" element={<NewPost />} />
                    <Route path="/admin/edit/:id" element={<EditPost />} />
                  </Route>

                  {/* 404 Route */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <CookieConsent />
            </div>
          </BrowserRouter>
        </TooltipProvider>
      </ThemeProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
